import { toast } from 'react-toastify'

export const handleGooglePaymentError = (error) => {
  if (error instanceof Error) {
    toast.error('GooglePay Error: ' + error.message)
    console.log('GooglePay Error:', error, error.message, error.stack)
  } else {
    toast.error('GooglePay Error: ' + error.statusMessage)
    // console.log('GooglePay Error', error.statusCode, error.statusMessage)
    console.log('GooglePay Error:', error.statusMessage)
  }
}
